import { itemModesMultiValuesRequired, itemModesSingleValueRequired } from '@common/filter/modes';
import { FilterOptions } from '@/filter/types';
import { prop, pluck, uniqBy } from 'ramda';
import { Project } from './types';
import { ProjectUser } from '@/types';

type ProjectType = 'owned' | 'invited' | 'joined';

export default ({
  owners,
  teamMembers,
  types,
}: {
  teamMembers: Array<{ id: string; fullname: string }>;
  owners: Array<{ id: string; fullname: string }>;
  types: Array<{ name: string; id: ProjectType }>;
}): FilterOptions<
  Project & { type: ProjectType },
  {
    ProjectNameFilter: 'text';
    ProjectTypeFilter: { id: ProjectType; name: string };
    CommentFilter: 'text';
    OwnerFilter: ProjectUser;
    TeamMemberFilter: ProjectUser;
  }
> => ({
  ProjectNameFilter: {
    type: 'text',
    getText: prop('name'),
  },

  ProjectTypeFilter: {
    type: 'item',
    allowedModes: {
      is: 'singleSelect',
    },
    getItems: (item) => [{ id: item.type, name: item.name }],
    getText: prop('name'),
    props: {
      buttonComponent: 'BasePill',
      itemComponent: null,
      items: types,
    },
  },

  CommentFilter: {
    type: 'text',
    getText: prop('description'),
  },

  OwnerFilter: {
    type: 'item',
    getText: prop('fullname'),
    allowedModes: itemModesSingleValueRequired,
    getItems: (item) => [prop('owner', item)],
    props: {
      buttonComponent: 'UserPill',
      itemComponent: 'UserIcon16',
      getDisplayText: prop('fullname'),
      items: owners,
    },
  },

  TeamMemberFilter: {
    type: 'item',
    getText: prop('fullname'),
    allowedModes: itemModesMultiValuesRequired,
    getItems: (item) => [prop('owner', item)].concat(pluck('user', item.activeTeamMembers)),
    props: {
      buttonComponent: 'UserPill',
      itemComponent: 'UserIcon16',
      items: uniqBy(prop('id'), owners.concat(teamMembers)).map((user) => ({
        id: user.id,
        name: user.fullname,
        // necessary for the SelectPopover search input
        fullname: user.fullname,
      })),
    },
  },
});
